const isInactiveProject = state => state.project && state.project.status === 'INACTIVE';

export default {
  isInactiveProject,
};
